import { FaArrowLeft } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { Autoplay, EffectCoverflow, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import KRajyotsavaData2025 from "../../../../../../Data/Events/2025/KRajyotsavaData2025";
import "../../CSSBlogs/MainBlogsCSSFile.css";

const KRajyotsavaDay2025 = () => {
    return (
        <>
            <section className="carousel_slider_section">
                <div className="container carouselSliderFirstInnerDiv">
                    <div className="row justify-content-center">
                        <div className="col-md-12">
                        <Swiper
                                effect={"coverflow"}
                                grabCursor={true}
                                centeredSlides={true}
                                slidesPerView={"auto"}
                                coverflowEffect={{
                                    rotate: 0,
                                    stretch: 0,
                                    depth: 100,
                                    modifier: 2,
                                    // slideShadows: true,
                                }}
                                // pagination={{
                                //     clickable: true,
                                //     dynamicBullets: true,
                                // }}
                                loop={true}
                                autoplay={{ delay: 3000 }}
                                navigation={true}
                                modules={[EffectCoverflow, Navigation, Autoplay]}
                                className="mySwiper"
                            >
                                {
                                    KRajyotsavaData2025.map((items) => {
                                        return (
                                            <SwiperSlide className="swiperSlide" key={items.id}>
                                                <div className="swiper-slide-img">
                                                    <img src={items.imageSource} alt="Avatar" className='nexus' />
                                                </div>
                                            </SwiperSlide>
                                        )
                                    })
                                }
                            </Swiper>
                        </div>
                    </div>
                </div>
            </section>
            <section className="blogs-heading-and-para-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 blog-heading-and-para-div">
                            <h1>Karnataka Rajyotsava #2025</h1>
                            <p>November 1st, 2025 was not just any other working day at Holistic Learning. On this special day the atmosphere seemed to buzz with energy as every corner of Holistic Learning was filled with red and yellow. This became quite symbolic of the occasion. Holistic Learning Team came together to mark the occasion and take part in this coveted statehood day celebrations. As the day began everything felt special as everyone came dressed in traditional clothes in red and yellow.</p>
                            <p>To say the least these colours did justice to the theme of the occasion. These bright colours reflected our spirit and symbolised our pride and love for Karnataka. The tone was set for a day which promised fun, laughter, and togetherness.</p>
                            <p>Our morning began as usual with work however there was buzz of excitement in the air as all of us were looking forward to a day which looked promising and exciting. We had a hearty lunch and the festivities kicked off in the second half.</p>
                            <p>The first event of the day was quite symbolic as everyone took part in <b>Karnataka Quiz</b>; testing the participants how much they know about their beloved state on the day the state got its statehood. All the participants did extremely well which displayed their affection towards our beloved state. Next game in the line was the <b>Map Game</b>. In this game the participants raced against the time to locate different places across Karnataka. This game seemed a bit challenging as participants rediscovered the Geography of Karnataka probably in the most unexpected way.</p>
                            <p>Next in store was the hilarious <b>Tongue Twister Round</b>. The game was filled with a lot of laughter as participants found it really challenging to get the answers right. Then came the most awaited game of the day the “<b>Wrong Answer Game”</b> The game filled the entire workspace with a laughter as the loudest applauses were being reserved for the silliest of the answers turning the entire atmosphere jolly. Finally, the <b>Fill in the Blanks</b> challenge tested how well everyone knew Karnataka, ending the games segment on a high note.</p>
                            <p>As the day came to a close all the winners proudly received their prizes. It was followed by a joyful photo session which wrapped up the eventful day in some style. The cameras captured some beautiful smiles which will last in our memories for a very long time.</p>
                            <p>This Karnataka Rajyotsava celebration at our office was much beyond fun and games as we got a chance to show where we truly belong and why the state makes us proud. The day reminded us when we come together for a purpose, great things start taking shape in astonishing ways.</p>
                        </div>
                        <div className="col-md-6 blog-writer-div">
                            <p>Written By ~ Aishik Roy Choudhury</p>
                        </div>
                        <div className="col-md-6 blog-button-div">
                            <NavLink to={"/events/more-events"} className="href">
                                <button>
                                    <span className="icon">
                                        <FaArrowLeft />
                                    </span>{" "}
                                    View All Events
                                </button>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default KRajyotsavaDay2025;
